<template>
  <div
    class="step-block"
    :class="stepBlockClass"
    @click="handleClick"
  >
    <i
      class="check-icon check-icon--low"
      v-if="checkable"
    ></i>
    <a
      class="img-zoom"
      v-if="zoomable"
      ref="zoom"
      :data-mediabox="title"
      :data-title="title"
      :href="zoomImage"
    >
      <span class="icon icon-zoom-plus-sign"></span>
    </a>
    <slot name="cover">
      <figure v-if="coverImage">
        <div
          class="step-block__cover"
          :style="{ backgroundImage: `url('${coverImage}')` }"
        >
          <slot name="labels">
            <div class="labels" v-if="labels && labels.length > 0">
              <span
                v-for="(item, index) in labels"
                :key="`${item.name}-${index}`"
              >
                <img v-if="item.icon" :src="item.icon">
                <template v-else>{{ item.name }}</template>
              </span>
            </div>
          </slot>
        </div>
      </figure>
    </slot>
    <slot>
      <div class="step-block__content">
        <slot name="body">
          <slot name="heading">
            <h2
              class="heading"
              v-if="title || titleImage"
              :class="headingClass"
              @click.stop.prevent="toggleCollapseBody"
            >
              <template v-if="title && !titleImage">
                {{ title }}
                <span v-if="subtitle">
                  {{ subtitle }}
                </span>
              </template>
              <template v-else>
                <img
                  class="img-fluid"
                  :src="titleImage"
                >
              </template>
            </h2>
          </slot>
          <collapse-transition>
            <div class="step-block__body" v-show="bodyVisible">
              <slot name="content" />
              <slot name="attributes">
                <ul class="list" v-if="attributes && attributes.length > 0">
                  <li
                    v-for="(attribute, index) in attributes"
                    :key="`${attribute.name}-${index}`"
                  >
                    <span class="list-ico" v-if="attribute.photo">
                      <img :src="attribute.photo">
                    </span>
                    <div class="list__content" v-if="attribute.name || attribute.value">
                      <span v-if="attribute.name">
                        {{ attribute.name }}
                      </span>
                      <span v-if="attribute.value">
                        <b>{{ attribute.value }}</b>
                      </span>
                    </div>
                  </li>
                </ul>
              </slot>
              <slot name="description">
                <template v-if="shortDescription || description">
                  <div class="description" v-if="shortDescription">
                    <button
                      class="text-link text-link--mobile modal-trigger"
                      type="button"
                      v-if="descriptionExpandable"
                      @click.prevent.stop="handleExpandDescription"
                    >
                      {{ $t('more') }}
                    </button>
                    <p>{{ shortDescription }}</p>
                  </div>
                  <div
                    class="description"
                    v-if="descriptionExpandable"
                  >
                    <button
                      class="text-link text-link--desktop modal-trigger"
                      type="button"
                      @click.prevent.stop="handleExpandDescription"
                    >
                      {{ $t('readMore') }}
                    </button>
                  </div>
                </template>
                <slot name="afterDescription"></slot>
              </slot>
            </div>
          </collapse-transition>
        </slot>
      </div>
    </slot>

    <v-modal
      :visible.sync="descriptionModal.visible"
      :title="descriptionModal.title"
      :append-to-body="true"
      @closed="handleDescriptionModalClose"
    >
      <div
        v-if="descriptionModal.content"
        v-html="descriptionModal.content">
      </div>
    </v-modal>
  </div>
</template>

<script>
  import { CollapseTransition } from 'vue2-transitions';

  export default {
    name: 'StepBlock',
    props: {
      title: String,
      subtitle: String,
      titleImage: String,
      coverImage: String,
      checked: Boolean,
      shortDescription: String,
      description: String,
      descriptionExpandable: Boolean,
      zoomImage: String,
      labels: {
        type: Array,
        default: () => [],
      },
      attributes: {
        type: Array,
        default: () => [],
      },
      checkable: {
        type: Boolean,
        default: true,
      },
      zoomable: {
        type: Boolean,
        default: false,
      },
    },
    mounted() {
      const { $refs } = this;

      if (window.WAMediaBox && $refs.zoom) {
        window.WAMediaBox.bind($refs.zoom);
      }
    },
    data() {
      return {
        descriptionModal: {
          visible: false,
          title: null,
          content: null,
        },
        bodyExpanded: false,
      };
    },
    methods: {
      toggleCollapseBody() {
        this.bodyExpanded = !this.bodyExpanded;
      },
      handleClick() {
        this.$emit('click');
      },
      handleExpandDescription() {
        this.descriptionModal = {
          visible: true,
          title: this.title,
          content: this.description,
        };
      },
      handleDescriptionModalClose() {
        this.descriptionModal = {
          visible: false,
          title: null,
          content: null,
        };
      },
    },
    computed: {
      stepBlockClass() {
        const { checked } = this;
        return [checked ? 'current' : null];
      },
      headingClass() {
        const { titleImage } = this;

        return [titleImage ? 'heading-img' : null];
      },
      bodyVisible() {
        const { $mq, bodyExpanded } = this;
        return ($mq === 'xs' && bodyExpanded) || $mq !== 'xs';
      },
    },
    components: {
      CollapseTransition,
    },
  };
</script>
